<template>
    <div class="docer-aside">
        <div class="aside-header" id="aside_header">
            <!-- <a href="javascript:void(0);" class="icon-contact" id="btn_contact"></a> -->
            <a href="javascript:void(0);" class="icon-menu" id="btn_menu"></a>
            <div class="menu-wrapper" id="menu_wrapper" v-show="menuVisible">
                <a href="javascript:void(0);"
                    v-on:click="qingOpenUrl('https://account.wps.com/usercenter/?from=mywps')"
                    ga="/userframe/usercenter;click">User Center
                </a>
                <!-- <a href="javascript:void(0);" v-on:click="qingOpenUrl('https://store.wps.com/user/subscription/?from=mywps')">Device Setting</a> -->
                <a href="javascript:void(0);"
                    v-show="isLogin"
                    v-on:click="userLogout()"
                    ga="/userframe/signout;click">Sign Out
                </a>
            </div>
        </div>

        <div class="user-wrapper tac clearfix" v-if="isLogin">
            <img src="../../assets/images/discount_flag_v2.png"
                class="discount-flag"
                v-show="discount.shouldShow && userInfo.vip_level != 210"
                @click="goDiscount()" />
            <img :src="userInfo.avatar" class="user-avatar" />
            <p class="user-nickname">{{ userInfo.nickname || 'unknown' }}</p>
            <a class="user-subscribe"
                href="javascript:void(0);"
                v-show="userInfo.vip_level != 210"
                v-on:click="goPremium">Go Premium
            </a>
        </div>

        <div class="user-wrapper tac" v-else-if="!isLogin">
            <i class="icon-login"
                v-on:click="userLogin()"
                ga="/userframe/avatar;click">
            </i>

            <p class="user-msg">{{ discount.shouldShow ? '' : '1G free cloud storage for WPS user' }}</p>

            <button class="btn-login"
                v-on:click="userLogin()"
                ga="/userframe/getit;click">{{ discount.shouldShow ? 'Sign in for Discount' : 'Get It' }}
            </button>
        </div>

        <div :class="isLogin ? 'dividing-line login-divide' : 'dividing-line logout-divide'"></div>

        <div class="file-tips clearfix">
            <span class="pull-left">
                <span class="dib">Recent files</span>
                <i id="icon_refresh" class="icon-refresh" v-on:click="getRectFiles()"></i>
            </span>
            <span class="pull-right" v-if="isLogin">
                <span class="dib" title="Documents that opened with WPS Office are automatically uploaded to WPS Cloud -> My Cloud -> Auto uploaded.">Auto upload</span>

                <i
                    :class="roamingMode === 'auto' ? 'icon-switch-active' : 'icon-switch'"
                    v-on:click="setRoamingMode(roamingMode)"
                    :ga="'/userframe/fileroamingservice;' + roamingMode === 'auto' ? 'open' : 'close'">
                </i>
            </span>
            <span class="pull-right" v-else-if="!isLogin">
                <span class="dib">
                    <a href="javascript:void(0);"
                        class="a-tdu"
                        v-on:click="userLogin()"
                        ga="/userframe/signin;click">Sign in
                    </a>
                </span>
                <span class="dib">to get Cloud documents</span>
            </span>
        </div>

        <ul class="file-list" v-bind:style="{ height: setListHeight(userInfo.userid ? 280 : 350), minHeight: '50px' }" v-if="fileLists.length > 0">

            <li v-for="(file, index) in fileLists">
                <a href="javascript:void(0);"
                    :class="file.isExist ? 'ellipsis' : 'file-not-exist ellipsis'"
                    :title="file.isExist ? file.fileName : 'Invalid record. This file may be renamed, deleted or moved'"
                    v-on:click="openFile(file)">

                    <i class="icon-file-cloud" v-if="file.isCloudFile"></i>
                    <i class="icon-file" v-else-if="!file.isCloudFile"></i>
                    <span class="dib">{{ file.fileName.substr(0, 30) }}</span>

                    <span :class="file.isExist ? 'file-handle' : 'file-handle file-handle-unexist'">
                        <i class="rm-rect" @click.stop="removeRectFile(file)" title="Clear Record from List"></i>
                        <span v-if="file.isExist">
                            <i v-if="file.isFixed" class="rm-rect-fix" @click.stop="removeRectFixedFile(file)" title="Unfixed from List"></i>
                            <i v-else class="add-fix" @click.stop="addRectFixedFile(file)" title="Fixed to List"></i>
                        </span>
                    </span>

                </a>
            </li>

        </ul>

        <div class="no-file" v-else-if="fileLists.length === 0">
            <i class="icon-file-empty"></i>
            <p class="fs14">There is no recent file!</p>
        </div>

        <div type="button" class="btn-more-file" v-on:click="openFileDialog()">
            <i class="icon-more-file"></i>
            <span class="dib text-more-file">Get more files</span>
        </div>
    </div>
</template>

<script>
import InSearch from '../common/InSearch.vue';
import Util from '../../assets/js/util.js';

const _start = new Date();
let rotateLock = false;

export default {
    components: {
        InSearch
    },

    data: () => ({
        userInfo: {},

        roamingMode: 'manual',

        fileLists: [],

        menuVisible: !1,
    }),

    computed: {
        isUwp() {
            return this.$store.state.uwp;
        },
    },

    props: {
        isLogin: {
            type: Boolean,
            default: false
        },
        discount: {
            type: Object
        },
    },

    watch: {
        isLogin(data) {
            if (data) {
                this.getUserInfo();
                this.getRoamingMode();
            } else {
                this.userInfo = {};
                //清除cookie
                Util.Cookie.create('wps_sid', null, -10000000, '.wps.com');
                Util.Cookie.create('wps_vip', null, -10000000, '.wps.com');
                VEvts.$emit('VIP_STATUS_CHANGE');
            }
        }
    },

    mounted() {
        // 功能键
        this.btnMenu();
        // 获取最近文档
        this.getRectFiles();

        Util.gaReport('send', 'timing', '/userframe', 'load', new Date() - _start);
    },

    methods: {
        btnMenu() {
            let _this = this;
            let btn = document.getElementById('btn_menu'),
                wrapper = document.getElementById('menu_wrapper');

            let timer;
            let hideMenu = function () {
                clearTimeout(timer);
                timer = setTimeout(function () {
                    _this.menuVisible = !1;
                }, 100);
            };
            let showMenu = function () {
                clearTimeout(timer);
                _this.menuVisible = !0;
            };

            btn.addEventListener('mouseover', function (e) {
                showMenu();
            });
            btn.addEventListener('mouseout', function (e) {
                hideMenu();
            });

            wrapper.addEventListener('mouseover', function (e) {
                showMenu();
            });
            wrapper.addEventListener('mouseout', function (e) {
                hideMenu();
            });
            wrapper.addEventListener('click', function (e) {
                e = e || window.event;
                let target = e.target || e.srcElement;

                if (target.tagName === 'A') {
                    hideMenu();
                }
            });
        },

        getUserInfo() {
            let _this = this,
                param = {
                    'http_method': 'POST',
                    'urlbase': 'https://cloud.wps.com',
                    'urlapi': '/api/v2/auth/check',
                    'contentType': 'application/json'
                };

            param.data = JSON.stringify({ 'info': 1, 'csrfmiddlewaretoken': 'docer' });
            Util.jsAsynCall('doAuthHttpRequest', param, true)
                .then(function (res) {
                    const data = res.response_data.user || {};
                    _this.userInfo = {
                        avatar: data.pic,
                        userid: data.userid,
                        nickname: data.nickname,
                        wps_sid: data.wps_sid,
                        accessid: data.accessid,
                        vip_level: data.vip_level || 10
                    };

                    Util.Cookie.create('wps_sid', data.wps_sid, undefined, '.wps.com');

                    if(data.vip_level == 210) {
                        Util.Cookie.create('wps_vip', 1, undefined, '.wps.com');
                        _this.$store.commit('change_vip_status', true);
                    } else {
                        Util.Cookie.create('wps_vip', 0, undefined, '.wps.com');
                        if (_this.discount.shouldShow) {
                            Util.gaReport('send', 'event', '/showDiscount', 'show', 'discount');
                        }
                    }

                    VEvts.$emit('VIP_STATUS_CHANGE', data.userid);
                })
                .catch(function() {
                    _this.userInfo = {};
                });
        },

        getRectFiles() {
            let _this = this;
            // 旋转视效
            if (!rotateLock) {
                Util.elemRotate('icon_refresh', 2, function (elem) {
                    rotateLock = false;
                });
                rotateLock = true;
            }

            Util.jsAsynCall('getRectFiles', true)
                .then(function (res) {
                    _this.fileLists = res.files.reverse();
                })
                .catch(function() {
                    _this.fileLists = [];
                });
        },

        getRoamingMode() {
            let _this = this;

            Util.jsAsynCall('getRoamingMode', true)
                .then(function (res) {
                    _this.roamingMode = res.mode;
                });
        },

        setRoamingMode(curMode) {
            let MODE = ['manual', 'auto'], mode;

            if (!~MODE.indexOf(curMode) || curMode === 'auto') {
                mode = 'manual';
            } else if (curMode === 'manual') {
                mode = 'auto';
            }

            Util.jsAsynCall('setRoamingMode', { 'mode': mode });
            this.roamingMode = mode;
        },

        userLogin() {
            Util.jsAsynCall('qingLogin');
        },

        userLogout() {
            Util.jsAsynCall('qingLogout');

        },

        openFile(file) {
            if (!file.isExist) {
                return false;
            }

            let param = {};
            if (file.isCloudFile) {
                param = {
                    isCloudFile: true,
                    fileid: file.fileid,
                    fileName: file.fileName
                };
            } else {
                param = {
                    isCloudFile: false,
                    fullPath: file.fullPath
                };
            }

            Util.gaReport('send', 'event', '/userframe/openfiles', 'click');
            Util.jsAsynCall('openFile', param);
        },

        qingOpenUrl(url) {
            Util.jsAsynCall('qingOpenVipUrl', { 'callbackurl': url });
        },

        openFileDialog() {
            Util.gaReport('send', 'event', '/userframe/opendialog', 'click');
            Util.jsAsynCall('openFileDialog');
        },

        setListHeight(_h) {
            return Util.setHeight(_h);
        },

        goDiscount() {
            Util.popupPayment('premium&feature=docer&price_option=subs_12months')
                .then(() => {})
                .catch(err => {
                    Util.goAvengateCart({
                        productId: 8,
                        couponCode: this.discount.shouldShow ? this.discount.couponCode : '',
                        source: 'WPS_SUBS_V12_Docer2Vip_Signin_Discount_Flag',
                    });
                });
            Util.gaReport('send', 'event', 'signinDiscount/flag', 'click', '12 months');
        },

        goPremium() {
            if (!this.isLogin) {
                Util.jsAsynCall("qingLogin");
                return;
            }
            Util.popupPayment('premium&feature=docer&price_option=subs_12months')
                .then(() => {})
                .catch(err => {
                    Util.goAvengateCart({
                        productId: 8,
                        source: 'WPS_SUBS_V12_Docer_Userpane',
                    });
                });
            Util.gaReport('send', 'event', '/userframe/gopremium', 'click');
        },

        addRectFixedFile(file) {
            try {
                Util.jsAsynCall('addRectFixedFile', { fullPath: file.fullPath }, true);
                this.getRectFiles();
            } catch (err) {
                console.log('addRectFixedFile err', err);
            }
            Util.gaReport('send', 'event', '/userframe/fixedRectFile', 'click');
        },

        removeRectFile(file) {
            try {
                Util.jsAsynCall('removeRectFile', {
                    fullPath: file.fullPath,
                    fileid: file.fileid,
                    isCloudFile: file.isCloudFile,
                    virtualId: file.virtualId,
                }, true);
                this.getRectFiles();
            } catch (err) {
                console.log('removeRectFile err', err);
            }
            Util.gaReport('send', 'event', '/userframe/removeRectFile', 'click');
        },

        removeRectFixedFile(file) {
            try {
                Util.jsAsynCall('removeRectFixedFile', { fullPath: file.fullPath }, true);
                this.getRectFiles();
            } catch (err) {
                console.log('removeRectFixedFile err', err);
            }
            Util.gaReport('send', 'event', '/userframe/unfixedRectFile', 'click');
        },
    }
}
</script>

<style>
.docer-aside {
    position: relative;
    width: 320px;
    height: 100%;
    min-height: 400px;
    float: left;
    font-size: 12px;
    text-align: center;
}

.aside-header {
    position: relative;
    width: 100%;
    height: 60px;
    background-position: -10px -10px;
}

.aside-header .icon-menu,
.aside-header .icon-contact {
    position: absolute;
    top: 10px;
    right: 12px;
}

.aside-header .icon-contact {
    right: 40px;
}

.menu-wrapper {
    position: absolute;
    top: 28px;
    right: 6px;
    padding: 5px 0;
    border: 1px solid #ededef;
    border-radius: 2px;
    background: #fff;
    box-shadow: 0 5px 5px #ccc;
    text-align: left;
    z-index: 1;
}

.menu-wrapper a {
    display: block;
    width: 95px;
    padding: 5px 12px;
    margin: 0;
}

.aside-header .menu-wrapper a {
    color: #222226;
}

.menu-wrapper a:hover {
    background: #ededef;
}

.user-wrapper {
    position: relative;
    margin-top: -33px;
}

.user-avatar {
    width: 72px;
    height: 72px;
    border-radius: 50%;
}

.user-msg {
    margin: 10px 0 16px;
    font-size: 16px;
}

.user-nickname {
    margin: 4px 0;
    color: #424242;
    font-size: 18px;
}

.user-subscribe {
    float: right;
    margin-right: 12px;
    font-size: 12px;
    color: #4082d2;
    border-bottom: 1px solid #4082d2;
}

.file-tips {
    padding: 0 20px;
    margin: 17px 0 4px;
}

.file-list {
    margin-right: 14px;
    overflow: auto;
}

.file-list a {
    display: block;
    height: 24px;
    padding-left: 20px;
    margin-bottom: 3px;
    text-align: left;
    color: #202125;
}

.file-list a:hover {
    background-color: #cdddf6;
}

.file-list a:active {
    background-color: #bfcfe8;
}

.no-file {
    padding: 30px 0 0;
}

.btn-more-file {
    position: absolute;
    bottom: 17px;
    left: 50%;
    width: 148px;
    height: 30px;
    margin-left: -74px;
    font-size: 14px;
    color: #fff;
    cursor: pointer;
    border-radius: 1px;
    height: 28px;
    line-height: 28px;
}

.btn-more-file.disable {
    color: #a2a2a2;
    cursor: auto;
}

.btn-more-file .icon-more-file {
    margin-right: 4px;
    vertical-align: -4px;
}

.btn-more-file .text-more-file {
    vertical-align: top;
}

.logout-divide {
    margin: 25px 0 20px;
}

.login-divide {
    margin: 10px 0 14px;
}

.file-not-exist span {
    color: #a0a0a4;
}

.discount-flag {
    position: absolute;
    left: 10px;
    top: 8px;
    cursor: pointer;
}

.file-list .dib {
    display: inline-block;
    width: 210px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.file-list li:hover .file-handle {
    display: block;
}

.file-handle {
    float: right;
    display: none;
    margin-right: 5px;
}

.file-handle.file-handle-unexist {
    display: block;
}

.add-fix {
    display: inline-block;
    width: 16px;
    height: 16px;
    background: no-repeat url('../../assets/images/filepageunfixed.png');
    vertical-align: middle;
}

.add-fix:hover {
    background: no-repeat url('../../assets/images/filepageunfixed-act.png');
}

.rm-rect {
    display: inline-block;
    width: 16px;
    height: 16px;
    background: no-repeat url('../../assets/images/DeleteRecord.png');
    vertical-align: middle;
}

.rm-rect:hover {
    background: no-repeat url('../../assets/images/DeleteRecord-act.png');
}

.rm-rect-fix {
    display: inline-block;
    width: 16px;
    height: 16px;
    background: no-repeat url('../../assets/images/filepagefixed.png');
    vertical-align: middle;
}

.rm-rect-fix:hover {
    background: no-repeat url('../../assets/images/filepagefixed-act.png');
}
</style>



// WEBPACK FOOTER //
// UserFrame.vue?792a375d